// extracted by mini-css-extract-plugin
module.exports = {"uk-announcement":"style_uk-announcement__c325S","container":"style_container__7ijbL","messageContainer":"style_messageContainer__2ozXq","message":"style_message__TY__4"};